import type { RouteObject } from 'react-router';
import { AlertPage } from './AlertPage';
import { IncidentPage } from './IncidentPage';
import { ServicePage } from './ServicePage';

/** Extra ops detail routes (paths without a leading slash). */
export const OPS_ROUTES: RouteObject[] = [
  { path: 'ops/incidents/:id', element: <IncidentPage /> },
  { path: 'ops/services/:name', element: <ServicePage /> },
  { path: 'ops/alerts/:name', element: <AlertPage /> },
];
